import axios, { AxiosResponse } from "axios";

export const requestInboundMail = async () => {
  const res = await axios.post("/company/request-inbound-mail");
  return res;
};

export const getCompanyInfo = async () => {
  const res = await axios.get("/company");
  return res;
};

export const getCompanies = async () => {
  const res = await axios.get("/company/list");
  return res;
};
